import { Column, Row } from "Components/Grid"
import { Button } from 'Components/ui'
import styled from 'styled-components'

const TitleLogin = styled.span`
  font-family: 'Rubik', sans-serif;
  font-weight: 300;
  font-size: 36px;
  color: var(--vo-ink);
  &.bold {
    font-weight: 700;
    color: var(--vo-celeste);
  }
`
import { ReactComponent as SuccessIcon } from '../../../assets/success.svg'
import { useParams } from "react-router-dom"
import { useQuery } from "react-query"
import { editCompanyPlan } from "services/company-service"
import { useTranslation } from 'react-i18next';

const SuccessTitle = styled.span`
  color: var(--color-brand-live);
  font-weight: 700;
  font-size: 24px;
`

const TextBold = styled.span`
  color: var(--vo-ink);
  font-weight: 700;
  font-size: 16px;
`

const TextBody = styled.span`
  color: var(--vo-ink);
  font-weight: 400;
  font-size: 14px;
`

const TextCaption = styled.span`
  color: var(--vo-slate);
  font-weight: 400;
  font-size: 14px;
  width: fit-content;
`


export const OnboardSuccess = () => {
    const { t } = useTranslation(['company']);
    const { slug, plan } = useParams()

    useQuery(['editCompanyPlan', slug, plan], async () => {
        if (!slug) return
        if (!plan) return
        await editCompanyPlan(slug, {plan})
    })
    const redirect = () => {
        const urlSplit = window.location.origin.split('/')
        const baseUrl = urlSplit[2].substring(3)
        window.location.href = `https://${slug}.${baseUrl}/login`
    }
    return (
        <div>
            <Row>
                <Column xs={12} className="text-center mb-3 mt-5">
                    <TitleLogin>Virtual</TitleLogin>
                    <TitleLogin className="bold"> Officer</TitleLogin>
                </Column>
                <Column xs={12} className="text-center mb-3">
                    <SuccessTitle>{t('company:onboard.success.paymentApproved')}</SuccessTitle>
                </Column>
                <Column xs={12} className="text-center mb-3">
                    <SuccessIcon
                        width="80px"
                        height="80px"
                        style={{ margin: '0 auto 24px', display: 'flex' }}
                        />
                </Column>
                <Column xs={12} className="text-center mb-3">
                    <TextBold>{t('company:onboard.success.accountCreated')}</TextBold>
                </Column>
                <Column xs={12} className="text-center mb-3">
                    <TextBody>{t('company:onboard.success.instructions')}</TextBody>
                </Column>
                <Column xs={'auto'} flex justifyContent="end" className="mb-3 ml-auto pr-0">
                    <TextCaption>{t('company:onboard.success.enterNow')}</TextCaption>
                </Column>
                <Column xs={'auto'} className="mb-3 mr-auto pl-0">
                    <Button
                      variant="ghost"
                      onClick={() => redirect()}
                      style={{ color: 'var(--color-brand-live)', fontWeight: 700, textTransform: 'none', padding: 0 }}
                    >
                        {t('company:onboard.success.login')}
                    </Button>
                </Column>
            </Row>
        </div>
    )
}
